<template>
	<div>
		<section class="section-title-page container-fluid" style="background-image: url('resources/img/example.jpg')">
			<div class="container">
				<div class="wrapper">
					<h1>Cumpleaños <small style="font-weight: 300"> hoy día</small></h1>
					<span>
						Volver <i class="fa fa-angle-right mx-1"></i>
						<a href="/">Inicio</a>
					</span>
				</div>
			</div>
		</section>
		<section class="container-birthdays container-fluid">
			<div class="container">
				<div class="all-birthdays" v-if="onomastics.Colegiados.length > 0">
					<div class="col-md-4 mb-3" v-for="(value, k) in onomastics.Colegiados" :key="k">
						<div class="box">
							<div class="img-person" :style="{ backgroundImage: 'url(' + value.foto + ')' }"></div>
							<div class="text">
								<h3>{{ value.colegiado }}</h3>
								<p class="m-0">CMVP: 5724</p>
							</div>
						</div>
					</div>
				</div>
				<div class="all-birthdays" v-else>
					<div class="section-info w-100">
						<p class="m-0"><i class="fa-solid fa-ban mr-2"></i><strong>Lo sentimos</strong>, hoy no hay ningún onomástico registrado.</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	name: 'onomastico',
	computed: {
		...mapState(['empresa'])
	},
	created() {},
	mounted() {
		this.getOnomasticos()
	},
	data() {
		return {
			onomastics: []
		}
	},
	methods: {
		...mapMutations(['setLoading']),
		getOnomasticos() {
			this.$http.get('ws_collegiate/list_onomastic').then((res) => {
				this.onomastics = res.data
				console.log(res.data.Colegiados)
			})
		}
	}
}
</script>
